module.exports = {"653123100":"城镇","653123101":"乌恰镇","653123200":"城关乡","653123201":"乔勒潘乡","653123202":"龙甫乡","653123203":"芒辛乡","653123204":"色提力乡","653123205":"萨罕乡","653123206":"英也尔乡","653123207":"克孜勒乡","653123208":"托普鲁克乡","653123209":"苏盖提乡","653123211":"艾古斯乡","653123212":"依格孜也尔乡","653123401":"英吉沙工业园区","653123500":"兵团东风农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653123.json
// module id = 2891
// module chunks = 0